import React from "react"
import {Customer} from "../../resources/customer"
import {Claims, useIsUnitUser} from "../../services/auth"
import {Account} from "../../resources/account"
import {CheckDeposit} from "../../resources/checkDeposits"
import {CheckImageCard} from "../CheckDeposits/CheckImageCard"
import {CheckDepositDetails} from "../CheckDeposits/CheckDepositDetails"
import {CheckDepositRiskFlags} from "../CheckDeposits/CheckDepositRiskFlags"

interface AssignmentCheckDepositProps {
	checkDeposit?: CheckDeposit
	title?: string
	account?: Account
	customer?: Customer
	disabled?: boolean
	singleColumn?: boolean
	accessToken?: string
	claims?: Claims
	className?: string
	frontImage?: ArrayBuffer | null | undefined
	backImage?: ArrayBuffer | null | undefined
	showUpdateModal?: () => void
}

export default function AssignmentCheckDepositDetails({
	checkDeposit,
	claims,
	frontImage,
	backImage,
	showUpdateModal,
}: AssignmentCheckDepositProps) {
	const isUnitUser = useIsUnitUser(claims)

	return (
		<div className="assignment-item-details-container">
			{checkDeposit && (
				<>
					<div className="check-image-card-section">
						<CheckImageCard
							frontImage={frontImage}
							backImage={backImage}
							id={checkDeposit.id}
							status={checkDeposit.attributes.status}
							compact={true}
						/>
					</div>

					<div className="check-data-container">
						<div className="check-data-container-left">
							<CheckDepositDetails
								showUpdateModal={showUpdateModal}
								amount={checkDeposit.attributes.amount}
								number={checkDeposit.attributes.checkNumber}
								customerId={checkDeposit.relationships.customer?.data.id}
								accountId={checkDeposit.relationships.account?.data.id}
								depositDate={checkDeposit.attributes.createdAt}
								description={checkDeposit.attributes.description}
								settlementDate={checkDeposit.attributes.settlementDate}
								tags={checkDeposit.attributes.tags}
								orgId={isUnitUser ? checkDeposit.relationships.org?.data.id : undefined}
							/>
						</div>

						<div className="check-data-container-right">
							<CheckDepositRiskFlags riskFlags={checkDeposit.attributes.riskFlags} />
						</div>
					</div>
				</>
			)}
		</div>
	)
}
